import classNames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../styles/outcomeEffectBox.module.scss";

const ContOutcomeEffectBox = ({ data, type }) => {
  return (
    <div
      className={classNames(styles.contOutcomeEffectBox, styles[`${type}Box`])}
    >
      <div dangerouslySetInnerHTML={{ __html: data }} />
    </div>
  );
};

ContOutcomeEffectBox.propTypes = {
  data: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default ContOutcomeEffectBox;
